// extracted by mini-css-extract-plugin
export default {"container":"unsupportedBrowserPage_container__noE-Z","text":"unsupportedBrowserPage_text__jGvQr","button":"unsupportedBrowserPage_button__bULjd"};